module.exports = __webpack_public_path__ + "img/Gazena_120X35.b54ab8ff.png";